import { render } from "./MatchContent3.vue?vue&type=template&id=1896e1a8&scoped=true"
import script from "./MatchContent3.vue?vue&type=script&lang=js"
export * from "./MatchContent3.vue?vue&type=script&lang=js"

import "./MatchContent3.vue?vue&type=style&index=0&id=1896e1a8&scoped=true&lang=css"
import "./MatchContent3.vue?vue&type=style&index=1&id=1896e1a8&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1896e1a8"]])

export default __exports__